import type { BaseAPIResponse } from '~/types/api';
import type { AuthUser } from '~/types/auth/auth';
import { ApiError } from '~/utils/errors';

// Pure API service - no state management
export const authService = {
    async getMe(): Promise<AuthUser> {
        const nuxtApp = useNuxtApp();

            const { data, status, message } = await usePbApi<BaseAPIResponse<AuthUser>>(nuxtApp.$api.routes.me.getMe());

            if (status !== 200) {
                const statusCode = status || 500;
                throw new ApiError(message || 'Error while fetching user info', statusCode);
            }

            if (!data?.data) {
                throw new ApiError('No user data received', 404);
            }

            return data.data;
    },
}; 